"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// determines whether two values are the same value

/* istanbul ignore next */
// eslint-disable-next-line
var isPolyfill = function isPolyfill(v1, v2) {
  return v1 === 0 && v2 === 0 ? 1 / v1 === 1 / v2 : v1 !== v1 && v2 !== v2 || v1 === v2;
};

var _default = Object.is || isPolyfill;

exports["default"] = _default;
//# sourceMappingURL=is.js.map